import { render } from "./SurveyPatientForm.vue?vue&type=template&id=4feb71fd"
import script from "./SurveyPatientForm.vue?vue&type=script&lang=js"
export * from "./SurveyPatientForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__